import React, { useEffect, useState } from 'react'
import copStyle from "./CorporateForm.module.css"
import Box from '@mui/material/Box';
import { Button, TextField, Typography } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import axios from 'axios';
const CorporateForm = () => {


  const [checkData, setCheckData] = useState([]);

  const getData = async () => {

    try {
      const res = await axios.get(`${process.env.REACT_APP_STEELADMIN}/form/GetAllCorporateFormCheck`).then((res) => {

        setCheckData(res.data.map(((data) => {

          let per = JSON.parse(data.permission);

          return {
            ...data,
            permission: per
          }
        })));


      })
    } catch (error) {
      console.log(error)
    }

  }



  useEffect(() => {
    getData();
  }, [])

  const handleCheckBox = (id, permissionId) => {
    console.log(id, "dsadsa", permissionId)
    setCheckData((prev) => {
      const updatedData = prev.map((dd) => {
        if (dd.id === id) {
          return {
            ...dd,
            permission: {
              ...dd.permission,
              [permissionId]: !dd.permission[permissionId],
            },
          };
        }
        return dd;
      });

      return updatedData;
    });


  }


  const handelSubmit = () => {



    const convertedData = checkData.map((item) => {

      if (typeof item.permission === "object" && !Array.isArray(item.permission)) {

        item.permission = Object.values(item.permission);
      }
      return item;
    });


    try {


      const res = axios.post(`${process.env.REACT_APP_STEELADMIN}/form/setCorpoarateForm`, convertedData).then((res) => {
        setCheckData(res.data.map(((data) => {

          let per = JSON.parse(data.permission);

          return {
            ...data,
            permission: per
          }
        })));
      })
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <div className={copStyle.Main}>
      <Box className={copStyle.Start}>
        <Typography variant='h2'>Business Details</Typography>
        <form action="">

          {checkData.map((data) => {
            return (
              <Box className={copStyle.Rolecheck} key={data.id}>
                <label>{data.name} </label>
                <FormGroup className={copStyle.RolesCheckGroup} >
                  <FormControlLabel
                    control={<Checkbox checked={data.permission[1]} onChange={() => handleCheckBox(data.id, 1)}/>}
                    label={<Typography className={copStyle.newOne}>Mandatory field</Typography>}
                  />
                  <FormControlLabel
                    control={<Checkbox checked={data.permission[0]} onChange={() => handleCheckBox(data.id, 0)}/>}
                    label={<Typography className={copStyle.newOne}>display on website</Typography>}
                  />
                </FormGroup>
              </Box>


            )
          })}


          <Box className={copStyle.RoleButton}>
            <Button onClick={handelSubmit} variant='contained' className={copStyle.saveButton}>Save changes</Button>
          </Box>
        </form>
      </Box>
    </div>
  )
}

export default CorporateForm
